import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"

import { InfiniteScroll } from "@nosto/preact"

export default function Category() {
    // const {
    //     response: { products },
    //     loading
    // } = useAppState()
    // const foundProducts = products && products.total > 0

    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"

    return (
        <>
            {/* <Toolbar lableFor={toggleButtonId} /> */}
            <div
                // class="collection-contents ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto"
                class="collection-contents ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-my-0 ns-mx-auto"
                data-nosto-element="search"
            >
                <Sidebar toggleId={toggleButtonId} />
                {/* div flex column and toolbar are new */}
                <div class="flex-column w-100">
                    <Toolbar lableFor={toggleButtonId} category/>
                    <div
                        class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5 product-card-wrapper"
                        style={loading ? "position: relative;" : ""}
                        id="nosto-product-card-wrapper--collection"
                    >
                        {/* {foundProducts ? (
                            <>
                                <SelectedFilters />
                                <Products />
                                <BottomToolbar />
                            </>
                        ) : loading ? (
                            <Loader />
                        ) : (
                            <NoResults />
                        )} */}

                        {/* To enable InfiniteScroll - comment above block and uncomment below.
                            Don't forget to import InfiniteScroll component. */}
                        {foundProducts ? (
                            <>
                                <InfiniteScroll>
                                    <Products category/>
                                </InfiniteScroll>
                            </>
                        ) : loading ? (
                            <Loader />
                        ) : (
                            <NoResults />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}



// Aug 12
// return (
//     <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto">
//         {foundProducts && (
//             <>
//                 <Sidebar />
//                 <Toolbar mobile />
//             </>
//         )}
//         <div class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5">
//             {foundProducts ? (
//                 <>
//                     <SelectedFilters />
//                     <Toolbar />
//                     <Products />
//                     <BottomToolbar />
//                 </>
//             ) : loading ? (
//                 <Loader />
//             ) : (
//                 <NoResults />
//             )}

//             {/* To enable InfiniteScroll - comment above block and uncomment below.
//                 Don't forget to import InfiniteScroll component. */}
//             {/* {foundProducts ? (
//                 <>
//                     <SelectedFilters />
//                     <Toolbar />
//                     <InfiniteScroll>
//                         <Products />
//                     </InfiniteScroll>
//                 </>
//             ) : loading ? (
//                 <Loader />
//             ) : (
//                 <NoResults />
//             )} */}
//         </div>
//     </div>
// )